import { useMemo } from "react"

import { useTransportMutation } from "@/transport"

interface SendProjectAssignmentEmailInput {
  projectId: string
  isNewProject?: boolean
  simulationOutputId?: string | null
}

type SendProjectAssignmentEmailOptions = Parameters<
  typeof useTransportMutation<"sendProjectAssignmentEmail">
>[1]

function toTransportRequest(input: SendProjectAssignmentEmailInput) {
  return {
    project_id: input.projectId,
    is_new_project: input.isNewProject,
    simulation_output_id: input.simulationOutputId,
  }
}

export function useProjectAssignmentEmailTransport(
  options?: SendProjectAssignmentEmailOptions,
) {
  const mutation = useTransportMutation("sendProjectAssignmentEmail", options)

  return useMemo(
    () => ({
      ...mutation,
      mutate: (
        input: SendProjectAssignmentEmailInput,
        mutateOptions?: Parameters<typeof mutation.mutate>[1],
      ) => mutation.mutate(toTransportRequest(input), mutateOptions),
      mutateAsync: (
        input: SendProjectAssignmentEmailInput,
        mutateOptions?: Parameters<typeof mutation.mutateAsync>[1],
      ) => mutation.mutateAsync(toTransportRequest(input), mutateOptions),
    }),
    [mutation],
  )
}
